import { useNavigate } from "react-router-dom";
import tokenHelper from "../../helpers/tokenHelper";
import { useEffect, useState } from "react";
import clientsApi from "../../api/client/client";
import apiClient from "../../api/client";
import usersApi from "../../api/user/user";
import { t } from "i18next";
import { ui } from "../../helpers/ui";

const InitSettingsLogic = () => {
  const navigate = useNavigate();

  const [client, setClient] = useState<any>();

  const loadClient = () => {
    clientsApi
      .getMe()
      .then(async (response) => {
        if (response.status === 200) {
          setClient(response.data);
        }
      })
      .catch((e) => {
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  useEffect(() => {
    loadClient();
  }, []);

  const onLogout = async () => {
    try {
      await apiClient.post<any>(`/delete-subscription`);
    } catch (e) {
      // Ignoriši
    }
    tokenHelper.removeToken();
    navigate("/");
  };

  const onTrainings = () => {
    navigate("/bookings");
  };

  const onHome = () => {
    navigate("/home-client");
  };

  const togglePushNotifications = async (
    disabledPushNotifications: boolean,
  ) => {
    await usersApi.updateDisabledPushNotificationsByCurrentUser();
    loadClient();
    ui.toast(
      `${t("Obaveštenja su")} ${disabledPushNotifications ? t("UKLJUČENA") : t("ISKLJUČENA")}`,
      "success",
    );
  };

  return {
    client,
    onLogout,
    onTrainings,
    onHome,
    togglePushNotifications,
  };
};

export default InitSettingsLogic;
